import React from 'react';
import numberFormat from 'number-format.js';

import {compareKPINumber, getKPINumber} from './utils';
import CompareTo from './CompareTo';

interface KPIChartHeaderProps {
  label: string;
  column: string;
  format: string;
  isPercentage: boolean;
  sourceData: any;
  compareToShow: boolean;
  compareToType: string;
  compareToColumn: string;
  compareToFormat: string;
  compareToIsPercentage: boolean;
}

const KPIChartHeader = ({
  label,
  column,
  format,
  isPercentage,
  sourceData,
  compareToShow,
  compareToType,
  compareToColumn,
  compareToFormat,
  compareToIsPercentage,
}: KPIChartHeaderProps) => {
  const kpiNumber = getKPINumber(sourceData, column, isPercentage);

  return (
    <div className="kpi-card-form__chart__header">
      <div className="left-side">
        <div className="label bp4-text-overflow-ellipsis">{label || column}</div>
        <div
          className="value"
        >{numberFormat(format, kpiNumber)}</div>
      </div>
      <div className="right-side">
        <div className="value">
          {
            compareToShow &&
            <CompareTo
              compareTo={compareToType}
              value={compareKPINumber(
                sourceData,
                column,
                compareToType,
                compareToColumn,
                compareToIsPercentage,
              )}
              format={compareToFormat}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default KPIChartHeader;
